import React, { useState } from 'react';

const SelectOffice = ({ offices, selectedOfficeId, setSelectedOfficeId, officeSelected, setOfficeSelected, officeNameProper, setOfficeNameProper }) => {
    //officeSelected is a bool which tells us if its been selected or not
    //selectedOfficeId is the office (Id) that has been selected

    const [officeSelectionError, setOfficeSelectionError] = useState('');
    const [officeName, setOfficeName] = useState('');

    const renderOption = (option) => (
        <option id={`${option.officeId}`} key={`${option.officeId}`} value={option.officeName}>
            {option.officeName}
        </option>
    );

    const block = {
        display: 'inline-block'
    }

    const borderOffice = {
        borderRadius: 5.7,
        borderColor: '#2ed9c3',
        borderStyle: 'solid',
        borderWidth: 3
    }

    const handleContinue = async () => {
        if (selectedOfficeId == null) {
            setOfficeSelectionError('An office has not been selected. Please select and click continue.');
        }
        else {
            setOfficeSelectionError('');
            setOfficeSelected(true);
            setOfficeNameProper(officeName);
        }
    }

    const handleSelectedOfficeId = (event) => {
        const index = event.target.selectedIndex;
        const optionElement = event.target.childNodes[index];
        setOfficeName(optionElement.getAttribute('value'));
        const selectedOfficeId = optionElement.getAttribute('id');
        setSelectedOfficeId(selectedOfficeId);
    };

    return (
        <div data-testid="select-office-component" className="container mb-5" style={borderOffice}>

            {(officeNameProper ?? '') === '' ? (<span style={block}>&nbsp;</span>) : (
                <>
                    <div className="row">
                        &nbsp;
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {offices === null || (offices != null && offices.length === 1)
                                ?
                                (<span style={block}>{officeNameProper} is the billing branch for the search</span>)
                                :
                                (<span style={block}>You have selected {officeNameProper} as the billing branch for the search</span>)}
                        </div>
                    </div>
                </>
            )}

            {offices == null && (officeNameProper ?? '') === '' ? (
                <div data-testid="div-loading-offices" className="row pb-5 pt-4">
                    <div className="col-12">
                        Loading offices.....
                    </div>
                </div>
            )
                :
                <>
                    {officeSelected ? (<span style={block}>&nbsp;</span>) : (<div>
                        <div data-testid="div-multiple-offices-message" className="row">
                            <div className="col-12">
                                We can see your law firm has multiple branches, can you confirm which branch you are requesting this search on behalf of?  We will use this information for billing purposes.
                            </div>
                        </div>
                        <div className="row">
                            &nbsp;
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <select className="form-select"
                                    id="selectOfficeDropdown"
                                    onChange={handleSelectedOfficeId}
                                >
                                    <option value="">Please select the billing branch</option>
                                    {offices.map((option, index) => renderOption(option, index))}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            &nbsp;
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <button type="button" className="fs-6 btn btn-dark" onClick={handleContinue}>CONFIRM BILLING BRANCH</button>
                            </div>
                        </div>
                        <div className="row pb-4">
                            <div className="col-12">
                                {officeSelectionError}
                            </div>
                        </div>
                    </div>)}

                </>
            }

        </div>
    );
}

export default SelectOffice;